/** Search params of `/platform/support-access`: a tenant to preselect, or the expiry notice (block C). */
export interface PlatformSupportAccessSearch {
  tenantId?: string;
  expired?: boolean;
}

export function platformSupportAccessSearchSchema(
  search: Record<string, unknown>,
): PlatformSupportAccessSearch {
  const tenantId = search['tenantId'];
  const expired = search['expired'];
  return {
    ...(typeof tenantId === 'string' && tenantId.length > 0 ? { tenantId } : {}),
    ...(expired === true || expired === 'true' ? { expired: true } : {}),
  };
}
